export enum ReservationRightSidePanels {
  TABLE_COMBINATIONS = 'tableCombinations',
  RESERVATION_SETTINGS = 'reservationSettings',
}
